module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Bar</span></div>\r\n<div id=\"propStyleFont\" class=\"style-text prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 prop-sublabel\" style=\"display: inline-flex;\">\r\n            <input id=\"barColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( barColor ))
    ; __append("\"\r\n                   style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n            <input id=\"barColor\" name=\"barColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" style=\"float:right; margin-left: 2px;\"\r\n                   value=\"")
    ; __append(escapeFn( barColor ))
    ; __append("\"/>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}